/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncUserDetails} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  InboxMsg: [],
  singleChat: [],
  replyData: {
    receiver: '',
  },
  sidebarRedDot: {},
}

const RouteUrl = {
  GetAllData: 'gateway/inbox-quick-sms',
  GetSingleChat: 'gateway',
  EditData: '',
  CreateData: 'gateway',
}
const thunkName = {
  GetAllData: 'gateway-GetAllInbox',
  GetData: '',
  EditData: '',
  CreateData: 'gateway-sendMsg',
  GetSingleChat: 'gateeay-singleChat',
}

export const sendSMSInbox: any = createAsyncThunk(
  'quickSms/sendSMSInbox',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_URL}gateway`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    let num = data?.contacts?.[0]
    let x = num?.[0].slice(0, 2)

    thunkApi.dispatch(
      GetSingleChat({
        page: 1,
        sortField: 'createdAt',
        sortOrder: 'descend',
        receiver: num,
        limit: 20,
        firstTime: true,
      })
    )
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

export const sendRMSChat: any = createAsyncThunk(
  'quickSms/sendRMSChat',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_URL}chat`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    let num = data?.contacts?.[0]
    let x = num?.[0].slice(0, 2)

    thunkApi.dispatch(
      GetSingleChat({
        page: 1,
        sortField: 'createdAt',
        sortOrder: 'descend',
        receiver: num,
        limit: 20,
        firstTime: true,
      })
    )
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)
export const sendRmsSMSInbox: any = createAsyncThunk(
  'quickSms/sendRmsSMSInbox',
  async (data: any, thunkApi: any) => {
    const response = await axios.post(`${API_URL}gateway`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    let num = data?.contacts?.[0]
    let x = num?.[0].slice(0, 2)

    thunkApi.dispatch(
      GetSingleRmsChat({
        id: data?.id,
      })
    )
    return response.data
  }
)

export const inboxArchiveFlag: any = createAsyncThunk(
  'inbox/archiveFlag',
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.put(
      `${API_URL}gateway/inboxFlagChange?receiver=${data.receiver}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
    // thunkApi.dispatch(GetAllData({sortField: 'createdAt', sortOrder: 'descend', size:  data?.limit}))
    // let num = data?.contacts?.[0]
    // let x = num?.[0].slice(0, 2)

    // thunkApi.dispatch(
    //   GetSingleRmsChat({
    //     id: data?.id,
    //   })
    // )
    return response.data
  }
)

export const GetSingleChat: any = createAsyncThunk(
  thunkName.GetSingleChat,
  async (data, thunkApi) => {
    const {firstTime, ...rest}: any = data
    if (firstTime) thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}${RouteUrl.GetSingleChat}`, {
      params: rest,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetSingleRmsChat: any = createAsyncThunk(
  'GetSingleRmsChat',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}chat/getSubscriberChatHistory/${data?.id}`, {
      params: {},
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetRmsChatList: any = createAsyncThunk('GetRmsChatList', async (data, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.get(`${API_URL}chat/getSubscriberList`, {
    params: data,
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})
export const GetAllData: any = createAsyncThunk(
  thunkName.GetAllData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    if (!data?.size) {
      data.size = 50
    }

    const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}`, {
      params: data,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
  }
)
export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}${RouteUrl.CreateData}/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status == true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})

export const InboxSmsBadge: any = createAsyncThunk('INBOX_SMS_BADGE', async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}gateway/inbox-sms-badge`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const ConversationBadge: any = createAsyncThunk(
  'CONVERSATION_BADGE',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}conversations/badge`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    // Transform response to match legacy format for compatibility
    const unreadCount = response.data?.data?.unreadCount || 0
    return {
      ...response.data,
      data: {
        isUnreadMessage: unreadCount > 0,
        unread: unreadCount,
      },
    }
  }
)

const InboxData = createSlice({
  name: 'InboxData',
  initialState,
  reducers: {
    ReplyInboxData: (state, {payload}) => {
      return {...state, replyData: payload}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, InboxMsg: action?.payload}
    })
    builder.addCase(GetSingleChat.fulfilled, (state, action) => {
      return {...state, singleChat: action?.payload}
    })
    builder.addCase(GetRmsChatList.fulfilled, (state, action) => {
      return {...state, rmsChats: action?.payload}
    })
    builder.addCase(GetSingleRmsChat.fulfilled, (state, action) => {
      return {...state, rmsSingleChats: action?.payload}
    })
    builder.addCase(InboxSmsBadge.fulfilled, (state, action) => {
      return {...state, sidebarRedDot: action?.payload}
    })
    builder.addCase(ConversationBadge.fulfilled, (state, action) => {
      return {...state, sidebarRedDot: action?.payload}
    })
  },
})

export const getSingleChat = (state: any) => state?.InboxData?.singleChat?.data
export const getSingleRmsChat = (state: any) => state?.InboxData?.rmsSingleChats?.data
export const getRmsChat = (state: any) => state?.InboxData?.rmsChats?.data
export const getAllChat = (state: any) => state?.InboxData?.InboxMsg?.data
export const getReplyInboxData = (state: any) => state?.InboxData?.replyData
export const getSidebarRedDotData = (state: any) => state?.InboxData?.sidebarRedDot?.data

export const {ReplyInboxData} = InboxData.actions
export default InboxData.reducer
